import BarcodeScanner from "react-qr-barcode-scanner";
import { Modal } from "antd";
import { useRef, useState } from "react";

const ScanMobile = ({ onScan, onClose }) => {
  const scannedRef = useRef(false);
  
return <Modal open footer={null} onCancel={onClose} centered >
    <div style={{ maxWidth: '500px', margin: '0 auto' }}>
    <h3>Сканирование</h3>

      <BarcodeScanner
        onUpdate={(err, result) => {
          if (result && !scannedRef.current) {
            scannedRef.current = true;
            onScan(result.text);
            onClose();
          }
        }}
        style={{ width: "100%" }}
      />
    </div>
  </Modal>
}

export default ScanMobile;